import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('TemplateWorkspaces');

export const templateWorkspaceQueries = {
  selectAll: baseQuery
};
